<script setup>
import { computed } from 'vue'
import { StrapiBlocks } from 'vue-strapi-blocks-renderer'

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  name: {
    type: String,
    required: true
  },
  headline: {
    type: String,
    required: false
  },
  description: {
    type: String,
    required: true
  },
  imgUrl: {
    type: String,
    required: true
  }
})

const imgSrc = computed(() => {
  return strapiUrl.replace(/\/$/, '') + props.imgUrl
})
const productsUrl = computed(() => {
  return '/products?category=' + props.id
})
</script>

<template>
  <v-card class="ma-2" density="compact" :title="name" :subtitle="headline" variant="text">
    <v-img height="300" :src="imgSrc" cover>
      <template v-slot:placeholder>
        <div class="d-flex align-center justify-center fill-height">
          <v-progress-circular color="grey-lighten-4" indeterminate />
        </div>
      </template>
    </v-img>

    <v-card-text class="pa-10">
      <StrapiBlocks :content="description" />
    </v-card-text>

    <template v-slot:actions>
      <v-btn color="primary" variant="text" :href="productsUrl">Produkte</v-btn>
    </template>
  </v-card>
</template>
